export function Header() {
  return (
    <header class="sticky top-0 z-20 border-b border-white/10 bg-slate-950/70 backdrop-blur-md">
      <div class="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <a href="/" class="flex items-center gap-2 text-lg font-black text-white">
          <span class="text-2xl">🏰</span>
          <span class="bg-gradient-to-r from-fuchsia-400 to-cyan-400 bg-clip-text text-transparent">
            Mighty Castle
          </span>
        </a>
        <nav class="flex items-center gap-8 text-sm font-medium text-slate-300">
          <a href="/" class="transition hover:text-white">Home</a>
          <a href="/posts" class="transition hover:text-white">Posts</a>
          <a href="/about" class="transition hover:text-white">About</a>
          <a href="/contact" class="transition hover:text-white">Contact</a>
        </nav>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer id="about" class="mt-24 border-t border-white/10">
      <div class="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-6 py-10 text-sm text-slate-400 sm:flex-row">
        <div class="flex items-center gap-2 font-black text-white">
          <span class="text-xl">🏰</span> Mighty Castle
        </div>
        <p>© 2026 mightycastle.net — built brick by brick.</p>
        <div class="flex gap-5">
          <a href="/sky" class="transition hover:text-white">Bluesky</a>
          <a href="/underground" class="transition hover:text-white">Underground</a>
          <a href="/contact" class="transition hover:text-white">Contact</a>
        </div>
      </div>
    </footer>
  );
}
